<template>
	<article v-if="section" class="section-page">
			<h1 class="mx-5 my-4">
				<ximg :src="iconImage" :ariaLabel="section.name" role="img" />
				{{ section.name }}
			</h1>
			<div v-if="section.description && section.description !== ''">
				<html-description class="page-description secondary" :html="section.description" :extended-html="section.extendedDescription" />
			</div>
			<home-component-selector v-if="components.length > 0" :toplists="toplists" :popularCategories="popularCategories" :components="components" :extraData="{ highlightSection: highlightSection }" class="parent-section"/>
		<div class="clearfix" />
	</article>
</template>
<script>
import waja from 'waja';
import bus from 'eventbus';
import router from 'router';
import store from 'datastore';
import { mapGetters } from 'vuex';
import { t } from 'datastore/i18n';
import mediaQuery from 'mediaQuery';
import metaHandler from 'metaHandler';
import { sectionIds } from 'staticData';
import { rollXHighlights, rollXComponents } from 'utils/highlight';
import { setSectionAndCategories } from 'datastore/navStatus';
import { error, convertToCdnUrl, urlFormat } from 'utils';
import { trackEvent } from 'gtm';

export default {
	store,
	data () {
		return {
			section: {},
			banner: null,
			highlights: null,
			topListsLoaded: false,
			components: [],
			sectionIds,
			toplists: null,
			popularCategories: null,
		};
	},
	layoutOptions: {
		leftCol: false,
	},
	handleTakeovers: true,
	handleNavigation () {
		return true;
	},
	handlesPrerender: true,
	beforeRouteEnter (to, frm, next) {
		waja.get('section/' + to.params.id + '/' + store.getters['i18n/regionCode'])
			.useCdn(true)
			.on('success', (res) => {
				next((vm) => {
					vm.components = res.data.homeComponents.components;
					const homeComponents = res.data.homeComponents;

					let toplist = [];
					rollXComponents((homeComponents.count['1'] || 0), homeComponents.toplists.filter(el => {
						if (el.hasBanner === false) {
							toplist.push(el);
						}
					}));

					const toplistWithBanner = rollXComponents((homeComponents.count['5'] || 0), homeComponents.toplists.filter(el => {
						return el.hasBanner === true;
					}));

					if (toplistWithBanner && toplistWithBanner.length > 0) {
						vm.toplists = toplist.concat(toplistWithBanner);
					} else {
						vm.toplists = toplist;
					}

					vm.popularCategories = rollXComponents(homeComponents.count['2'], homeComponents.popularCategories, exclusionList);

					vm.topListsLoaded = false;
					const exclusionList = [];
					// vm.banner = rollXHighlights(1, res.data.section.banners, exclusionList);
					vm.highlights = rollXHighlights(9, res.data.section.highlights, exclusionList);
					bus.$emit('takeover:update', rollXHighlights(1, res.data.section.takeovers));
					vm.section = res.data.section.section;
				});
			})
			.on('error', (err) => {
				if (err.status === 404) {
					next(error(404));
				} else {
					next(error(500, 'Det går för tillfället inte att komma åt denna sida. Försök gärna senare.'));
				}
			}).go();
	},
	beforeRouteUpdate (to, frm, next) {
		// Id params seem to be strings sometimes and numbers other times. Therefore,
		// "cast" them to numbers.
		if (~~to.params.id === ~~frm.params.id) {
			next(vm => {
				vm.onPageLoad();
			});
			return;
		}
		waja.get('section/' + to.params.id + '/' + store.getters['i18n/regionCode'])
			.useCdn(true)
			.on('success', (res) => {
				next((vm) => {
					vm.components = res.data.homeComponents.components;
					const homeComponents = res.data.homeComponents;

					let toplist = [];
					rollXComponents((homeComponents.count['1'] || 0), homeComponents.toplists.filter(el => {
						if (el.hasBanner === false) {
							toplist.push(el);
						}
					}));

					const toplistWithBanner = rollXComponents((homeComponents.count['5'] || 0), homeComponents.toplists.filter(el => {
						return el.hasBanner === true;
					}));

					if (toplistWithBanner && toplistWithBanner.length > 0) {
						vm.toplists = toplist.concat(toplistWithBanner);
					} else {
						vm.toplists = toplist;
					}

					vm.popularCategories = rollXComponents(res.data.homeComponents.count['2'], res.data.homeComponents.popularCategories, exclusionList);

					vm.topListsLoaded = false;
					const exclusionList = [];

					//vm.banner = rollXHighlights(1, res.data.section.banners, exclusionList);
					vm.highlights = rollXHighlights(9, res.data.section.highlights, exclusionList);
					bus.$emit('takeover:update', rollXHighlights(1, res.data.section.takeovers));
					vm.section = res.data.section.section;
				});
			})
			.on('error', () => {
				next(error(404));
			}).go();
	},
	computed: {
		showHighlightSection () {
			// Dirty hack to hide highlight section in the fyndware section.
			return this.section && this.section.id !== sectionIds.fyndwares;
		},
		highlightSection () {
			let max = 9;
			if (mediaQuery.lt('md')) {
				max = 6;
			}
			return {
				name: 'Aktuellt just nu',
				highlights: this.highlights.slice(0, max),
			};
		},
		iconImage () {
			if (this.section && this.section.color) {
				let color = '1A1A1D';
				if (this.section.id === sectionIds.apple) { // Fulhack för svart appleikon.
					color = '333333';
				}
				return convertToCdnUrl('/api/dynimg/category/' + this.section.icon + '/' + color);
			}
		},
		iconColor () {
			return this.isDark ? '39485d' : '1e222d';
		},
		showTopLists () {
			if (mediaQuery.current <= mediaQuery.sm) {
				return true;
			}
			return false;
		},
		...mapGetters({
			productTips: 'productTips/overflowingLists',
			// topLists: 'productTips/topLists',
			isLoggedIn: 'user/isLoggedIn',
			isDark: 'user/isDark',
		}),
	},
	methods: {
		convertToCdnUrl,
		onTopListsLoad () {
			this.topListsLoaded = true;
			this.onPageLoad();
		},
		onPageLoad () {
			if (this.topListsLoaded) {
				store.dispatch('prerender/pageLoaded');
			}
		},
		click(event) {
			trackEvent('gaEvent', 'Interactions', 'Menu Click', 'Category Page Menu');
		},
		ts: t.prefix('SECTION'),
	},
	mounted () {
		bus.$on('productTips:rendered', this.onTopListsLoad);
	},
	beforeDestroy () {
		bus.$off('productTips:rendered', this.onTopListsLoad);
	},
	watch: {
		section (to, frm) {
			if (frm && to.id === frm.id) {
				return;
			}
			router.updateParams({
				id: to.id,
				name: urlFormat(to.name),
			});

			if (to.metaDescription) {
				metaHandler.set('description', to.metaDescription);
			} else if (to.description) {
				metaHandler.set('description', to.description);
			} else {
				metaHandler.set('description', 'Upptäck vårt stora ' +
				'sortiment i avdelningen ' + to.name);
			}

			const section = to;
			setSectionAndCategories(to, []);
			if (store.getters['productTips/isTopListLoaded'](section)) {
				this.onTopListsLoad();
			}
			store.commit('productTips/setShowTopLists', true);
			store.dispatch('productTips/fetchTopLists', { section });
			store.commit('productTips/setShowLists', false);
		},
	},
};
</script>
